import React, { useMemo } from 'react';
import { rem, SettingsItemNavigate } from 'design-system';
import { selectFeatureFlag } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { StyleSheet, View } from 'react-native';
import { formatDateForItem } from 'utils';
import { toZonedTime } from 'date-fns-tz';
import { IconArrowBack } from 'design-system/icons';
import Text from 'design-system/Text';
import { RRule } from 'rrule';
import { isSameDay, isTomorrow } from 'date-fns';
import { TransactionBankLogo } from './TransactionBankLogo';
import TransactionLogo from './TransactionLogo';
const ScheduledTransactionRow = ({ schedule, backgroundDark, onPress, }) => {
    const bankLogoTransaction = useAppSelector((store) => selectFeatureFlag(store, 'bank_logo_transaction')).value;
    let localDate = schedule.nextOn
        ? toZonedTime(schedule.nextOn, Intl.DateTimeFormat().resolvedOptions().timeZone)
        : null;
    if (schedule.nextOn) {
        const isToday = isSameDay(new Date(schedule.nextOn), new Date());
        if (isToday) {
            const rule = RRule.fromString(schedule.rrule);
            const rruleWithStart = new RRule({
                ...rule.origOptions,
                dtstart: new Date(schedule.startDate),
            });
            const nextAfterNext = rruleWithStart.after(new Date(schedule.nextOn));
            if (nextAfterNext) {
                localDate = toZonedTime(nextAfterNext, Intl.DateTimeFormat().resolvedOptions().timeZone);
            }
        }
    }
    const icon = (<View style={styles.iconContainer}>
      <TransactionLogo R44 transaction={schedule} backgroundDark={backgroundDark}/>
      {bankLogoTransaction ? (<TransactionBankLogo id={schedule.accountId} isSmall/>) : null}
    </View>);
    const nextOnText = useMemo(() => {
        if (!localDate) {
            return '';
        }
        const isTodayOrTomorrow = isSameDay(new Date(localDate), new Date()) ||
            isTomorrow(new Date(localDate));
        return isTodayOrTomorrow ? 'Scheduled' : 'Scheduled on';
    }, [localDate]);
    return (<SettingsItemNavigate onPress={() => {
            if (schedule.id !== null) {
                onPress(schedule.id);
            }
        }} renderIcon={() => icon}>
      <View>
        <Text Text-16>{schedule.counterpartName}</Text>
        <View style={styles.frequencyDescriptionContainer}>
          <IconArrowBack width={12} height={12} gradientKey="darkPink"/>
          <Text TextThin-14 Gray>
            {`${nextOnText} ${localDate ? formatDateForItem(localDate) : ''}`}
          </Text>
        </View>
      </View>
    </SettingsItemNavigate>);
};
const styles = StyleSheet.create({
    frequencyDescriptionContainer: {
        // marginTop: rem(4),
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(4),
    },
    iconContainer: {
        marginRight: rem(16),
    },
});
export default ScheduledTransactionRow;
